import { trackEvent } from '@redux-beacon/google-analytics-gtag'
// module helpers
import { camel2Snake } from 'modules/Helpers'
// constant imports
import { category, ACTIONS, LABELS, WEBAPP, RCON } from 'constants/Analytics'
import { GUEST } from 'constants/Contacts'
import {
  OUTGOING_CREATE,
  INCOMING_BLOCK,
  INCOMING_ACCEPT,
  SESSION_TRANSFER,
  SESSION_TRANSFER_VOICEMAIL,
  SESSIONS_MERGE,
  SESSION_PARK_FULFILLED,
  SESSION_UNPARKED,
} from 'redux/Sessions/constants'

// helpers
// separator
const DASH = '-'
// source app
export const app = (state) => {
  const { modeFloat } = state.config

  return DASH + modeFloat ? RCON : WEBAPP
}
// call source participant type
const callSourceType = (state) => {
  let participant

  try {
    participant =
      state.sessions.list[state.sessions.activeSessionIndex].participant
  } catch (e) {
    return LABELS.OUTGOING.ERROR
  }

  let type = participant?.callDetails?.from?.type || participant.type

  if (type === GUEST && !participant.name) {
    type = 'external'
  }

  return DASH + camel2Snake(type)
}

// event functions
const blockedCallEvent = trackEvent((_, __, state) => ({
  category,
  action: ACTIONS.BLOCKED + app(state),
}))

const incomingCallEvent = trackEvent((_, __, state) => {
  // TODO get c2c working from custom header
  // const c2cStr = source?.c2c ? '_c2c' : ''

  return {
    category,
    action: ACTIONS.INCOMING + app(state),
    label: LABELS.INCOMING + callSourceType(state),
  }
})

const outgoingCallEvent = trackEvent((_, __, state) => {
  const { outgoingCallSource: label } = state.analytics

  return {
    category,
    label: label + callSourceType(state),
    action: ACTIONS.OUTGOING + app(state),
  }
})

const transferCallEvent = trackEvent((_, __, state) => ({
  category,
  action: ACTIONS.TRANSFER + app(state),
}))

const transferVoicemailCallEvent = trackEvent((_, __, state) => ({
  category,
  action: ACTIONS.TRANSFER_VOICEMAIL + app(state),
}))

const mergedCallEvent = trackEvent((_, __, state) => ({
  category,
  action: ACTIONS.MERGED + app(state),
}))

const parkCallEvent = trackEvent((_, __, state) => ({
  category,
  action: ACTIONS.PARK + app(state),
}))

const unparkCallEvent = trackEvent((_, __, state) => ({
  category,
  action: ACTIONS.UNPARK + app(state),
}))

// events maps
const AnalyticsEventsMap = {
  [INCOMING_BLOCK]: blockedCallEvent,
  [INCOMING_ACCEPT]: incomingCallEvent,
  [OUTGOING_CREATE]: outgoingCallEvent,
  [SESSION_TRANSFER]: transferCallEvent,
  [SESSION_TRANSFER_VOICEMAIL]: transferVoicemailCallEvent,
  [SESSIONS_MERGE]: mergedCallEvent,
  [SESSION_PARK_FULFILLED]: parkCallEvent,
  [SESSION_UNPARKED]: unparkCallEvent,
}

export default AnalyticsEventsMap
